// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".widget-icon{width:24px;height:24px}", "",{"version":3,"sources":["webpack://src/components/Icon.scss"],"names":[],"mappings":"AAAA,aACI,UAAA,CACA,WAAA","sourcesContent":[".widget-icon {\n    width: 24px;\n    height: 24px;\n} \n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
